import request from 'tools/request'

export const SET_CLIENT_FORM_CONFIG = 'SET_CLIENT_FORM_CONFIG'

export const setClientFormConfig = (data) => ({
  type: SET_CLIENT_FORM_CONFIG,
  data
})

export const verifyRecaptchaToken = (recaptchaToken) => async () => {
    return await request('v1/public/recaptcha', 'POST', { token: recaptchaToken, remoteIp: "" });
};

export const submitExternalApplication = (payload) => async () => {
  return await request('public/applications/external', 'POST', payload);
};

export const fetchClientFormConfig = (subdomain) => async (dispatch) => {
  const data = await request(`public/client-form-config/${subdomain}`, 'GET');
  dispatch(setClientFormConfig(data));
  return data;
};
